export default "__VITE_ASSET__CJIdwEbA__"